import { makeBrowserLifecycle, type RealtimeLifecycle } from '@st/sdk'
import { Context, Effect, Layer, Stream } from 'effect'
import { match } from '@st/pattern'
import { ErrorReporting } from './error-reporting'

export class BrowserLifecycle extends Context.Service<BrowserLifecycle, RealtimeLifecycle>()(
  'BrowserLifecycle'
) {}

export function browserLifecycleLayer() {
  return Layer.effect(
    BrowserLifecycle,
    Effect.gen(function* () {
      const lifecycle = yield* makeBrowserLifecycle()
      const errorReporting = yield* ErrorReporting

      return {
        ...lifecycle,
        events: lifecycle.events.pipe(
          Stream.tap((event) =>
            errorReporting.addBreadcrumb({
              level: 'info',
              category: 'lifecycle',
              message: match(event)
                .with({ _tag: 'VisibilityChanged' }, () => 'visibilitychange')
                .with({ _tag: 'PageHide' }, () => 'pagehide')
                .with({ _tag: 'PageShow' }, () => 'pageshow')
                .exhaustive(),
              data: {
                visibility: event.visibility,
                ...('persisted' in event ? { persisted: event.persisted } : {})
              }
            })
          )
        )
      }
    })
  )
}
